import React from 'react';
import Image from 'next/image';

const AgricultureNumbers = () => {
    return (
        <div className="section-py bg-primary_one relative">
            <div className="bg-agriculture-numbers">
                <Image
                    src="/img/agriculture-industry/svg/vector-agriculture-by-the-number.svg"
                    className="img-fluid !h-full"
                    alt="agriculture by the number"
                    title="agriculture by the number"
                    height={385}
                    width={1380}
                    loading="lazy"
                />
            </div>
            <div className="container xl:container mx-auto z-[1] relative">
                <div className="row grid lg:grid-cols-12 mb-9">
                    <div className="lg:col-span-10 gap-4 grid">
                        <h2 className="text-white mb-0">Agriculture by the Numbers</h2>
                    </div>
                </div>
                <div className="row grid xl:grid-cols-4 lg:grid-cols-4 md:grid-cols-4 grid-cols-2">
                    <div className="">
                        <p className="text-white mb-4 font-bold fs-xxl">70%</p>
                        <p className="text-white opacity-[0.8] mb-0 fs-md">
                            70% increase in yield possible through AI-driven precision farming
                        </p>
                    </div>
                    <div className="">
                        <p className="text-white mb-4 font-bold fs-xxl">40%</p>
                        <p className="text-white opacity-[0.8] mb-0 fs-md">
                            40% of ag businesses are investing in Smart Agriculture Solutions
                        </p>
                    </div>
                    <div className="">
                        <p className="text-white mb-4 font-bold fs-xxl">$22B+</p>
                        <p className="text-white opacity-[0.8] mb-0 fs-md">
                            $22B+ projected market size for agriculture software by 2025
                        </p>
                    </div>
                    <div className="">
                        <p className="text-white mb-4 font-bold fs-xxl">35%</p>
                        <p className="text-white opacity-[0.8] mb-0 fs-md">
                            Up to 35% reduction in operational costs using digital agriculture services
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default AgricultureNumbers;
